var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/core-js/date/now"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/core-js/date/now"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.now);
    global.index = mod.exports;
  }
})(this, function (_exports, _now) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _now = _interopRequireDefault(_now);
  // import { BEHAVIOR_TYPES_MAP } from '../constant'
  var _default = {
    init: function init(cb) {
      var _this = this;

      var OFFLINE_MILL = 15 * 60 * 1000; // 15分钟不操作认为不在线

      var SEND_MILL = 5 * 1000; // 每5s打点一次

      var lastTime = (0, _now.default)();
      window.addEventListener('click', function (event) {
        // let node
        // let outerHTML = (node = event.target ? event.target : event.srcElement) && node.outerHTML
        // let tagName = node && node.tagName
        // const needRecord = !['HTML', 'BODY'].includes(tagName)
        // if (outerHTML && outerHTML.length > 200) {
        //   outerHTML = outerHTML.slice(0, 200) + '...'
        // }
        // needRecord && this.behaviorQueue.enqueue({
        //   type: BEHAVIOR_TYPES_MAP.BEHAVIOR_TYPES_CLICK,
        //   timestamp: Date.now(),
        //   name: tagName,
        //   outerHTML: outerHTML,
        //   id: node && node.id,
        //   className: node && node.className,
        //   page: location.href
        // })
        if (_this.needRecordTimeOnPage === false) {
          _this.debugLogger("config.record.time_on_page\u503C\u4E3Afalse, \u8DF3\u8FC7\u505C\u7559\u65F6\u957F\u6253\u70B9");

          return;
        }

        var now = (0, _now.default)();
        var duration = now - lastTime;

        if (duration > OFFLINE_MILL) {
          lastTime = (0, _now.default)();
        } else if (duration > SEND_MILL) {
          lastTime = (0, _now.default)();

          _this.debugLogger('发送用户留存时间埋点, 埋点内容 => ', {
            duration_ms: duration
          }); // 用户在线时长


          cb && cb.call(_this, 10001, {
            duration_ms: duration
          });
        }
      }, true);
    }
  };
  _exports.default = _default;
});